import { Translation } from '@fullyops/shared/pipes/translate.pipe';
import { AssetFormTranslationKey } from './translate.pipe';

export const en: Translation<AssetFormTranslationKey> = {
  name: 'Name',
  assetType: 'Asset type',
  STANDALONE_EQUIPMENT: 'Standalone equipment',
  EQUIPMENT_GROUP: 'Equipment group',
  generic: 'generic',
  active: 'Active',
  createdAt: 'Created at',
  company: 'Company',
  companies: 'Companies',
  category: 'Category',
  location: 'Location',
  locations: 'Locations',
  parent: 'Parent',
  description: 'Description',
  externalId: 'External id',
  criticality: 'Criticality',
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  CRITICAL: 'Critical',
  installedAt: 'Installed at',
  hasWarranty: 'Has warranty',
  warrantyExpiresAt: 'Warranty expires at',
  warranty: 'Warranty',
  brand: 'Brand',
  model: 'Model',
  serialNumber: 'Serial number',
  type: 'Type',
  manufacturedAt: 'Manufactured at',
  noneCriticality: 'None',
  noneGeneric: 'None',
  any: 'Any',
  assetClass: 'Asset class',
  noWarranty: 'Not defined',
  inWarranty: 'In warranty',
  outOfWarranty: 'Out of warranty',
  create: 'Create',
  assetsPerPage: 'Assets per page',
  inactive: 'Inactive',
  change: 'Change',
  genericType: 'Generic',
  noCustomFields: 'No custom fields',
  oneCustomField: '1 custom field',
  customFields: 'custom fields',
  chooseAssetType: 'Choose the asset type',
  general: 'General info',
  ownershipAndLocation: 'Ownership & location',
  installationAndWarranty: 'Installation & warranty',
  equipmentDetails: 'Equipment details',
  customFieldsSection: 'Custom fields',
  attachments: 'Attachments',
  generalDescription: 'What the asset is and how critical it is',
  ownershipAndLocationDescription:
    "Who owns it, where it is and what it's part of",
  installationAndWarrantyDescription:
    "When it was installed and until when it's under warranty",
  equipmentDetailsDescription:
    'Manufacturer details that identify the equipment',
  customFieldsSectionDescription: 'Fields defined for this asset type',
  invalidInteger: 'Enter a whole number, e.g. 12',
  invalidDecimal: 'Enter a number, e.g. 12.5',
  status: 'Status',
  valueOutOfRange: 'Outside the allowed range:',
  attachmentsDescription: 'Manuals, certificates, photos and other files',
  openAsset: 'Open asset',
  close: 'Close',
  save: 'Save',
  add: 'Add',
  noCompanyAssets: 'This client has no assets yet',
};
